import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [ 
  {
    path: 'Procesos',
    loadChildren: 'app/content/pages/HCMModuleApp/AdmisionPersonal/procesos/procesos.module#ProcesosModule'
  },
  {
    path: 'Maestros',
    loadChildren: 'app/content/pages/HCMModuleApp/AdmisionPersonal/maestros/maestros.module#MaestrosModule'
  },
  {
    path: 'Reportes',
    loadChildren: 'app/content/pages/HCMModuleApp/AdmisionPersonal/reportes/reportes.module#ReportesModule'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdmisionPersonalRoutingModule { }